export const privacyUrl = 'https://www.scican.com/privacy/'
export const contactUrl = 'https://www.scican.com/contact/'
export const termsUrl = 'https://www.scican.com/terms/'
export const documentUploadInstructions = 'https://scican.atlassian.net/wiki/x/qYC5DQ'
export const videoUploadInstructions = 'https://scican.atlassian.net/wiki/x/AoDmEg'
export const firmwareUploadInstructions = 'https://scican.atlassian.net/wiki/x/HQK5DQ'
export const faultsUploadInstructions = 'https://scican.atlassian.net/wiki/x/-gG5DQ'
export const unitLanguagesUploadInstructions = 'https://scican.atlassian.net/wiki/x/AYBuFg'
export const productModelsUploadInstructions = 'https://scican.atlassian.net/wiki/x/AQBvFg'
export const sparepartsUploadSampleTemplate = 'spare-parts/lookup-file/Spareparts Lookup Updated.xltm'

